import React from 'react';
import { BottomNavigation, useTheme } from 'react-native-paper';
import DashboardScreen from '../screens/DashboardScreen';
import FinancesScreen from '../screens/FinancesScreen';
import TrucksScreen from '../screens/TrucksScreen';
import DriversScreen from '../screens/DriversScreen';
import JobsScreen from '../screens/JobsScreen';

const ROUTES = {
  dashboard: 'dashboard',
  finances: 'finances',
  trucks: 'trucks',
  drivers: 'drivers',
  jobs: 'jobs',
} as const;

const MainNavigator: React.FC = () => {
  const theme = useTheme();
  const [index, setIndex] = React.useState(0);

  const [routes] = React.useState([
    {
      key: ROUTES.dashboard,
      title: 'Dashboard',
      focusedIcon: 'view-dashboard',
      unfocusedIcon: 'view-dashboard-outline',
    },
    {
      key: ROUTES.finances,
      title: 'Finances',
      focusedIcon: 'cash-multiple',
      unfocusedIcon: 'cash-multiple',
    },
    {
      key: ROUTES.trucks,
      title: 'Fleet',
      focusedIcon: 'truck',
      unfocusedIcon: 'truck-outline',
    },
    {
      key: ROUTES.jobs,
      title: 'Jobs',
      focusedIcon: 'briefcase',
      unfocusedIcon: 'briefcase-outline',
    },
    {
      key: ROUTES.drivers,
      title: 'Users',
      focusedIcon: 'account-group',
      unfocusedIcon: 'account-group-outline',
    },
  ]);

  const navigateToHome = () => setIndex(0);
  const navigateToJobs = () => setIndex(routes.findIndex(r => r.key === ROUTES.jobs));

  const renderScene = ({ route }: { route: { key: string } }) => {
    switch (route.key) {
      case ROUTES.dashboard:
        return <DashboardScreen onNavigateToJobs={navigateToJobs} />;
      case ROUTES.finances:
        return <FinancesScreen />;
      case ROUTES.trucks:
        return <TrucksScreen onNavigateHome={navigateToHome} />;
      case ROUTES.drivers:
        return <DriversScreen />;
      case ROUTES.jobs:
        return <JobsScreen />;
      default:
        return null;
    }
  };

  return (
    <BottomNavigation
      navigationState={{ index, routes }}
      onIndexChange={setIndex}
      renderScene={renderScene}
      activeColor={theme.dark ? theme.colors.primary : theme.colors.onPrimary}
      inactiveColor={theme.dark ? theme.colors.onSurfaceVariant : 'rgba(255, 255, 255, 0.6)'}
      barStyle={{
        backgroundColor: theme.dark ? (theme.colors as any).surfaceContainer : theme.colors.primary,
      }}
    />
  );
};

export default MainNavigator;
